<template>
  <generic-modal :modal-key="'successful_exchange_stars'" :has-extra-modal-class="'popup_box op_down modal_cont'"
                 @close="$emit('close')">
    <template slot="content">
      <h1>{{ getTranslations.home_exchange_suc_modal_confirm }}</h1>
      <img src="static/images/stars/nojoom_logo.png" class="op_down_img">
      <p>{{ getTranslations.home_exchange_suc_modal_confirm_thank_you }}</p>
      <p>{{ getTranslations.home_exchange_suc_modal_confirm_access }} <a href="/">{{ getTranslations.home_exchange_suc_modal_confirm_here }}</a></p>
    </template>
  </generic-modal>
</template>

<script>
  // modal_confirm_exchange_stars_account
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters } from 'vuex';
import GenericModal from '../../sharedcomponents/GenericModal';

export default {
  name: 'successfulExchange',
  components: { GenericModal },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/stars/SuccessfulExchange.vue